import React, { useState } from "react";
import { PageShell, EditableSection } from "./PageShell";
import { toast } from "sonner";

const POSITION = [{
  heading: "Our position",
  body: "Scentodore does not sell your personal information for monetary consideration, and we do not share it for cross-context behavioural advertising. Nonetheless, if you wish to formally record an opt-out on file, submit the form below and we’ll log it against your email.",
}];
const AGENTS = [{
  heading: "Authorised agents",
  body: "If you’re submitting on behalf of another person, include a signed authorisation with the initial email. We may verify identity before processing.",
}];

export default function DoNotSellPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    const subj = encodeURIComponent(`[CCPA / Do Not Sell] Opt-out request — ${email}`);
    const body = encodeURIComponent(`Please record my opt-out from any sale or sharing of my personal information under CCPA / applicable law.\n\nEmail on file: ${email}`);
    window.location.href = `mailto:privacy@scentodore.com?subject=${subj}&body=${body}`;
    setTimeout(() => {
      toast.success("Opt-out email opened. Send when ready.");
      setSubmitting(false);
    }, 300);
  };

  return (
    <PageShell
      slug="do-not-sell"
      testid="do-not-sell"
      eyebrow="California Residents"
      title="Do Not Sell or Share My Personal Information"
      intro="Under the California Consumer Privacy Act (CCPA) and Colorado / Virginia / Connecticut equivalents, you have the right to opt out of the sale or sharing of your personal information."
    >
      <EditableSection slug="do-not-sell" sectionKey="position" fallback={POSITION} />

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Submit an opt-out</h2>
        <form onSubmit={onSubmit} data-testid="do-not-sell-form" className="grid sm:grid-cols-[1fr_auto] gap-3 max-w-xl">
          <input
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email on file with Scentodore"
            data-testid="do-not-sell-email"
            className="px-4 py-3.5 rounded-xl border border-black/10 bg-[#FAF8F5] text-sm focus:outline-none focus:border-[#C5A059]"
          />
          <button
            type="submit"
            disabled={submitting}
            data-testid="do-not-sell-submit"
            className="inline-flex items-center justify-center bg-[#1A1918] text-[#FAF8F5] px-5 py-3.5 rounded-xl text-xs uppercase tracking-[0.18em] hover:bg-[#C5A059] hover:text-[#0B0A08] transition-colors disabled:opacity-60"
          >
            {submitting ? "Opening…" : "Submit opt-out"}
          </button>
        </form>
      </div>

      <EditableSection slug="do-not-sell" sectionKey="agents" fallback={AGENTS} />
    </PageShell>
  );
}
